(function () {

    const ringSelection = {
        fieldsetID: null,
        locationAPIkey: '86f5f280-f4eb-11ec-8676-4f4388bc6daa',
        currentOption: null,
        currentCountry: 'us',
        currentUserCountry: 'us',
        sizeTable: {   // update ring size options here
            "F": 3,
            "G": 3.5,
            "H": 4,
            "I": 4.5,
            "J": 5,
            "K": 5.5,
            "L": 6,
            "M": 6.5,
            "N": 7,
            "O": 7.5,
            "P": 8,
            "Q": 8.5,
            "R": 9,
            "S": 9.5,
            "T": 10,
            "U": 10.5,
            "V": 11
        },
        euroCountries: [],
        init: () => {
            // find ring size heading and save element ID
            document.querySelectorAll('fieldset[id^="ProductSelect--product-template-option-"]').forEach((id, n) => {
                const heading = id.previousElementSibling.innerText;
                if (heading.match(/ring size/i)) {
                    ringSelection.fieldsetID = `#ProductSelect--product-template-option-${n}`;
                }
            })

            // if fieldset of ring sizes exists
            if (ringSelection.fieldsetID) {
                // get contents of sibling element
                const sectionLabelText = document.querySelector(ringSelection.fieldsetID).previousElementSibling.innerText;

                // get parent element
                const parentElement = document.querySelector(ringSelection.fieldsetID).parentElement;

                // if heading matches 'ring size' 
                if (sectionLabelText.match(/ring size/i)) {

                    // old header text
                    const headerText = document.querySelector(ringSelection.fieldsetID).previousElementSibling.innerText;

                    // hide old header
                    document.querySelector(ringSelection.fieldsetID).previousElementSibling.classList.add('ring-selection');

                    // construct ring selection header
                    const containerEl = document.createElement('div');
                    const labelEl = document.createElement('label');
                    const toggleEl = ringSelection.createToggle();
                    const chartContainerEl = document.createElement('div');

                    // ring selection header classes
                    containerEl.classList.add('ring-size');
                    labelEl.classList.add('ring-size__label');
                    toggleEl.classList.add('ring-size__toggle');
                    chartContainerEl.classList.add('ring-size__chart');

                    // heading text
                    labelEl.innerText = headerText;

                    // assemble header elements
                    containerEl.append(labelEl, toggleEl, chartContainerEl);

                    // add to dom
                    parentElement.prepend(containerEl);

                    // update toggle country
                    ringSelection.updateToggleCountry();

                    // move existing chart element to new header section if it exists
                    if (document.querySelector('.btn.size-chart-open-popup')) {
                        ringSelection.moveElement('.btn.size-chart-open-popup', '.ring-size__chart')
                    }

                    // apply classes and data to existing options
                    ringSelection.applyClasses();

                    // set state
                    ringSelection.currentOption = ringSelection.getSelectedOption();

                    // if user has not clicked
                    if (!sessionStorage.getItem("userClicked")) {
                        ringSelection.getUserCountry() // check location
                            .then(r => r.json())
                            .then(j => {
                                if (ringSelection.euroCountries.includes(j.country_code.toUpperCase())) {
                                    ringSelection.currentUserCountry = 'uk';
                                    ringSelection.currentCountry = ringSelection.currentUserCountry;
                                    ringSelection.toggleOptions()
                                    ringSelection.updateToggle()
                                }
                            })
                    }
                    else { // if user has clicked
                        // set previously selected option
                        if (sessionStorage.getItem('userCountryOption') !== ringSelection.currentCountry) {
                            ringSelection.currentCountry = sessionStorage.getItem('userCountryOption')
                            ringSelection.toggleOptions()
                            ringSelection.updateToggle()
                            ringSelection.updateToggleCountry()
                        }
                    }
                }
            }
        },
        updateSession: () => {
            sessionStorage.setItem("userClicked", true);
            sessionStorage.setItem("userCountryOption", ringSelection.currentCountry);
        },
        updateToggle: () => { // trigger toggle appearance change
            document.querySelector('#ring-toggle').checked = document.querySelector('#ring-toggle').checked ? false : true;
            ringSelection.updateToggleCountry();
        },
        updateToggleCountry: () => {
            document.querySelector('.ring-size__toggle').dataset.country = ringSelection.currentCountry;
        },
        getCurrentOptionCountry: () => {
            return ringSelection.currentOption.match(/.*[a-zA-Z].*/) ? 'uk' : 'us';
        },
        getUserCountry: () => { // fetch user location API and return promise
            const url = `https://geolocation-db.com/json/${ringSelection.locationAPIkey}`;
            return fetch(url);
        },
        getSelectedOption: () => { // get current checked option
            const checkedBox = document.querySelector(`${ringSelection.fieldsetID} input:checked`);
            const label = checkedBox.nextElementSibling;
            return label.innerText;
        },
        applyClasses: () => {
            document.querySelectorAll(`${ringSelection.fieldsetID} label`).forEach(l => {
                if (!l.innerText.match(/.*[a-zA-Z].*/)) {
                    l.dataset['sizeUs'] = l.innerText
                    l.dataset['sizeUk'] = ringSelection.getKeyByValue(l.innerText)
                }
                l.dataset['country'] = ringSelection.currentCountry

                l.onclick = (e) => { // on click of option, set state
                    ringSelection.currentOption = e.target.innerText
                    ringSelection.updateSession();
                }
            })
        },
        getKeyByValue: (value) => { // lookup us sizes by uk key
            const object = ringSelection.sizeTable;
            return Object.keys(object).find(key => String(object[key]) === String(value));
        },
        moveElement: (elementSelector, destSelector) => { // append dom element to another element
            let element = document.querySelector(elementSelector);
            let elementParent = element.parentElement;
            let destElement = document.querySelector(destSelector);
            elementParent.removeChild(element);
            destElement.appendChild(element);
        },
        createToggle: () => {
            // create toggle elements
            const switchContainerEl = document.createElement('label');
            const countryCodeUSEl = document.createElement('span');
            const countryCodeUKEl = document.createElement('span');
            const checkboxEl = document.createElement('input');
            const sliderEl = document.createElement('span');

            // add classes
            switchContainerEl.classList.add('switch');
            countryCodeUSEl.classList.add('country-code', 'country-code--us');
            countryCodeUKEl.classList.add('country-code', 'country-code--uk');
            sliderEl.classList.add('slider', 'round');
            checkboxEl.id = 'ring-toggle';

            // add content
            countryCodeUSEl.innerText = 'US';
            countryCodeUKEl.innerText = 'UK';
            checkboxEl.type = 'checkbox';

            // add click event
            checkboxEl.onclick = () => ringSelection.clickToggle();

            if (ringSelection.currentCountry == 'us') {
                checkboxEl.checked = true;
            }

            // assemble and add to dom
            switchContainerEl.append(countryCodeUSEl, countryCodeUKEl, checkboxEl, sliderEl);

            // return element
            return switchContainerEl;
        },
        toggleOptions: () => {
            document.querySelectorAll(`${ringSelection.fieldsetID} label`).forEach(l => {
                l.dataset['country'] = ringSelection.currentCountry
                l.innerText = l.getAttribute(`data-size-${ringSelection.currentCountry}`)
            })
        },
        clickToggle: () => {
            ringSelection.setCountry();
            ringSelection.toggleOptions();
            ringSelection.updateToggleCountry();
            ringSelection.updateSession();
        },
        setCountry: (value) => { // set country state
            if (value) {
                ringSelection.currentCountry = value;
            }
            else {
                ringSelection.currentCountry = ringSelection.currentCountry == 'uk' ? 'us' : 'uk';
            }
        },
        printState: () => {
            let div = document.createElement('div');
            let btn = document.createElement('button');
            btn.textContent = "reset";
            btn.classList.add('debug')
            btn.style.zIndex = 10000
            btn.onclick = () => {
                sessionStorage.removeItem("userClicked");
                sessionStorage.removeItem("userCountryOption");
                sessionStorage.removeItem("userOption");
            }
            div.classList.add('debug');
            document.body.append(btn)
            document.body.append(div)
        }
    }

    // start
    ringSelection.init();

})();